import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _wrapNativeSuper from "@babel/runtime-corejs2/helpers/esm/wrapNativeSuper";

/**
 * ¯\_(ツ)_/¯ Fixing support for Internet Explorer, Firefox
 * (DOMException exists but calling it's constructor throws error)
 * and other crappy browsers that do not support it natively.
 */
var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');

if (canUseDOM) {
  try {
    // tslint:disable-next-line:no-unused-expression
    new window.DOMException();
  } catch (error) {
    // @ts-ignore
    window.DOMException = /*#__PURE__*/function (_Error) {
      _inherits(DOMException, _Error);

      var _super = _createSuper(DOMException);

      function DOMException(message, name) {
        var _this;

        _classCallCheck(this, DOMException);

        _this = _super.call(this, message);
        _this.message = message;
        _this.name = name;
        return _this;
      }

      return DOMException;
    }( /*#__PURE__*/_wrapNativeSuper(Error));
  }
}

export function abortable(_x, _x2) {
  return _abortable.apply(this, arguments);
}

function _abortable() {
  _abortable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(invocable, options) {
    var isAborted, abortedError, onAbortCallback, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            isAborted = options.signal.aborted;
            abortedError = new DOMException('The operation was aborted.', 'AbortError');

            onAbortCallback = function onAbortCallback() {
              isAborted = true;
            };

            _context.prev = 3;

            if (!isAborted) {
              _context.next = 6;
              break;
            }

            throw abortedError;

          case 6:
            options.signal.addEventListener('abort', onAbortCallback);
            _context.next = 9;
            return invocable();

          case 9:
            response = _context.sent;

            if (!isAborted) {
              _context.next = 14;
              break;
            }

            throw abortedError;

          case 14:
            return _context.abrupt("return", response);

          case 15:
            _context.next = 20;
            break;

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](3);
            throw isAborted ? abortedError : _context.t0;

          case 20:
            _context.prev = 20;
            options.signal.removeEventListener('abort', onAbortCallback);
            return _context.finish(20);

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 17, 20, 23]]);
  }));
  return _abortable.apply(this, arguments);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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